module.exports = __webpack_public_path__ + "img/wondering.89df177f.svg";